export default __webpack_public_path__ + "static/Europe_Hero_Animation_updated-04aff54261c6f378fd91b2c578682130.webm";